import AuthServiceToken from './AuthServiceToken';
import AuthToken from './AuthToken';
import AwsApi from './AwsApi';
import ConferenceToken from './ConferenceToken';
import Core from './Core';
import Credentials from './Credentials';
import FileSharing from './FileSharing';
import KibanaLog from './KibanaLog';
import NextSchedule from './NextSchedule';
import PasswordFromPin from './PasswordFromPin';
import PersonalPresence from './PersonalPresence';
import PersonalToken from './PersonalToken';
import Recording from './Recording';
import SocialAuth from './SocialAuth';
import UserInfo from './UserInfo';
import UserPresence from './UserPresence';

const core = new Core();

core.init([
    AuthServiceToken,
    AuthToken,
    ConferenceToken,
    Credentials,
    UserInfo,
    PasswordFromPin,
    SocialAuth,
    UserPresence,
    NextSchedule,
    PersonalPresence,
    PersonalToken,
    Recording,
    FileSharing,
    KibanaLog,
    AwsApi
]);

export default core.generatedModules;
